<template>
  <section class="demo-section">
    <div class="demo-container">
      <!-- Columna izquierda: Contenido de texto -->
      <div class="text-content">
        <h2 class="demo-title">Agenda tu demo gratuita de Fourin Track</h2>
        <p class="demo-description">
          Descubre cómo optimizar la gestión de activos y el mantenimiento preventivo y predictivo
          en tu empresa con nuestro CMMS en la nube.
        </p>
      </div>

      <!-- Columna derecha: Formulario -->
      <div class="form-content">
        <div class="form-container">
          <form @submit.prevent="handleSubmit" class="demo-form">
            <div class="form-group">
              <label for="nombre">Nombre completo</label>
              <input
                type="text"
                id="nombre"
                v-model="formData.nombre"
                required
                placeholder="Tu nombre completo"
              />
            </div>

            <div class="form-group">
              <label for="empresa">Empresa</label>
              <input
                type="text"
                id="empresa"
                v-model="formData.empresa"
                required
                placeholder="Nombre de tu empresa"
              />
            </div>

            <div class="form-group">
              <label for="email">Correo electrónico</label>
              <input
                type="email"
                id="email"
                v-model="formData.email"
                required
                placeholder="tu@email.com"
              />
            </div>

            <div class="form-group">
              <label for="telefono">Teléfono</label>
              <input
                type="tel"
                id="telefono"
                v-model="formData.telefono"
                placeholder="+57 300 123 4567"
              />
            </div>

            <!-- <div class="form-group">
              <label for="empleados">Número de empleados</label>
              <select id="empleados" v-model="formData.empleados" required>
                <option value="">Selecciona una opción</option>
                <option value="1-10">1-10 empleados</option>
                <option value="11-50">11-50 empleados</option>
                <option value="51-200">51-200 empleados</option>
                <option value="201-500">201-500 empleados</option>
                <option value="500+">Más de 500 empleados</option>
              </select>
            </div> -->

            <div class="form-group">
              <label for="mensaje">Mensaje (opcional)</label>
              <textarea
                id="mensaje"
                v-model="formData.mensaje"
                rows="3"
                placeholder="Cuéntanos más sobre tus necesidades..."
              ></textarea>
            </div>

            <button type="submit" class="submit-button" :disabled="isSubmitting">
              <span v-if="!isSubmitting">Agendar Demo Gratuita</span>
              <span v-else>Enviando...</span>
              <svg
                v-if="!isSubmitting"
                class="submit-arrow"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 17L17 7M17 7H7M17 7V17"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div v-else class="loading-spinner"></div>
            </button>

            <!-- Mensaje de estado -->
            <div
              v-if="submitMessage"
              class="submit-message"
              :class="{
                success: !submitMessage.includes('error') && !submitMessage.includes('Error'),
              }"
            >
              {{ submitMessage }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const formData = ref({
  nombre: '',
  empresa: '',
  email: '',
  telefono: '',
  empleados: '',
  mensaje: '',
})

const isSubmitting = ref(false)
const submitMessage = ref('')

const handleSubmit = async () => {
  isSubmitting.value = true
  submitMessage.value = ''

  try {
    // Usar la función helper de Supabase
    const { submitDemoRequest } = await import('../lib/supabase')

    const data = await submitDemoRequest(formData.value)
    console.log('Solicitud guardada exitosamente:', data)

    submitMessage.value =
      '¡Gracias! Tu solicitud ha sido registrada. Nos pondremos en contacto contigo pronto.'

    // Resetear el formulario
    formData.value = {
      nombre: '',
      empresa: '',
      email: '',
      telefono: '',
      empleados: '',
      mensaje: '',
    }
  } catch (error) {
    console.error('Error:', error)
    submitMessage.value = 'Hubo un error enviando tu solicitud. Por favor intenta de nuevo.'
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style scoped>
.demo-section {
  padding: 20px 20px;
  background: linear-gradient(
    120deg,
    rgba(18, 155, 239, 1) 0%,
    rgba(14, 122, 188, 1) 20%,
    rgba(18, 155, 239, 1) 40%,
    rgba(14, 122, 188, 1) 60%,
    rgba(18, 155, 239, 1) 82%,
    rgba(14, 122, 188, 1) 100%
  );
  min-height: 90vh;
  display: flex;
  align-items: center;
}

.demo-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

/* Columna izquierda: Contenido de texto */
.text-content {
  color: white;
}

.demo-title {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 30px;
  max-width: 500px;
}

.demo-description {
  font-size: 18px;
  line-height: 1.6;
  opacity: 0.95;
  max-width: 450px;
}

/* Columna derecha: Formulario */
.form-content {
  display: flex;
  justify-content: center;
}

.form-container {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 40px;
  width: 100%;
  max-width: 450px;
}

.demo-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
}

.form-group select {
  cursor: pointer;
}

.form-group select option {
  background: #0ea5e9;
  color: white;
}

.submit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: white;
  color: #129bef;
  border: none;
  padding: 18px 32px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.submit-button:hover {
  background: #f8fafc;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.submit-arrow {
  transition: transform 0.3s ease;
}

.submit-button:hover .submit-arrow {
  transform: translate(2px, -2px);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submit-button:disabled:hover {
  transform: none;
  box-shadow: none;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #129bef;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.submit-message {
  margin-top: 15px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}

.submit-message.success {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #86efac;
}

/* Responsive design */
@media (max-width: 968px) {
  .demo-container {
    grid-template-columns: 1fr;
    gap: 60px;
    text-align: center;
  }

  .demo-title {
    font-size: 3rem;
    margin: 0 auto 30px auto;
  }

  .demo-description {
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .demo-section {
    padding: 80px 20px;
  }

  .demo-title {
    font-size: 2.5rem;
  }

  .demo-description {
    font-size: 16px;
  }

  .form-container {
    padding: 30px 25px;
  }
}

@media (max-width: 480px) {
  .demo-title {
    font-size: 2rem;
  }

  .form-container {
    padding: 25px 20px;
  }

  .submit-button {
    padding: 16px 28px;
    font-size: 14px;
  }
}
</style>
